import React, { useEffect, useState } from 'react'
import SearchIcon from '@mui/icons-material/Search'
import ClearIcon from '@mui/icons-material/Clear'
import { Box, InputAdornment, Link, TextField, Theme } from '@mui/material'

import { makeStyles } from '@mui/styles'

interface ISearchInputData {
  value?: string
  onChangeValue?: (value: string) => void
}

const useStyles = makeStyles((theme: Theme) => ({
  accountSearch: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  textField: {
    height: 'auto',
  },
  clearIcon: {
    paddingTop: theme.spacing(0.5),
    '&:hover': {
      cursor: 'pointer',
    },
  },
}))

const SearchInput: React.FC<ISearchInputData> = (props) => {
  const [value, setValue] = useState<string>(props.value ? props.value : '')
  const classes = useStyles()

  useEffect(() => {
    props.onChangeValue && props.onChangeValue(value)
  }, [value])

  return (
    // <div className={classes.accountSearch}>
    <div>
      <TextField
        className={classes.textField}
        id='search'
        label='Suchen'
        name='name'
        InputProps={{
          endAdornment: (
            <InputAdornment position='end'>
              <Box display='flex' alignItems='center'>
                {!value ? <SearchIcon />
                  : <Link onClick={() => setValue('')}><ClearIcon className={classes.clearIcon} /></Link>}
              </Box>
            </InputAdornment>
          ),
        }}
        InputLabelProps={{
          shrink: true,
        }}
        value={value}
        onChange={(event => setValue(event.target.value))}
        margin='none'
        size='small'
        variant='outlined'
        fullWidth
      />
    </div>
  )
}
export default SearchInput
